import React, { useState, useEffect } from 'react';
import HeaderForTeacherGroupsPage from '../../Components/HeaderForTeacherGroupsPage/HeaderForTeacherGroupsPage';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";

const GroupsPage = () => {

  const [filterTab, setFilterTab] = useState('Aktiv'); 
  const [groupsData, setGroupsData] = useState([]); 
  const [isDataLoading, setIsDataLoading] = useState(false);

  const fetchGroups = async (status) => {
    setIsDataLoading(true);

    try {
      const [res] = await Promise.all([
        apiFetch(BASE_URL+`/teacher-groups/status-filter`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ groupStatus: status }),
        }),
        new Promise((r) => setTimeout(r, 600)),
      ]);

      if (!res.ok) throw new Error("Server xətası baş verdi");

      const data = await res.json();
      if (data && data.teacherGroups) {
        setGroupsData(data.teacherGroups);
      } else {
        setGroupsData([]);
      }

    } catch (err) {
      console.error("Data fetch error:", err);
      setGroupsData([]);
    } finally {
      setIsDataLoading(false);
    }
  };


  useEffect(() => {
    fetchGroups(filterTab);
  }, [filterTab]);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: '#fcfcfc', padding: '12px 16px' }}>
      <HeaderForTeacherGroupsPage
        filterTab={filterTab}
        setFilterTab={setFilterTab}
        onRefresh={() => fetchGroups(filterTab)}
        groupsData={groupsData}
        isDataLoading={isDataLoading}
      />
    </div>
  );
};

export default GroupsPage;